import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useLoadStore } from '../../store';
import { GeneralGrainHeading } from './GeneraGrainlHeading';
import { GeneralGrainData } from './GeneralGrainData';
import { GeneralGrainForm } from './GeneralGrainForm';

export const GeneralGrainWrapper: FC = () => {
  const { id } = useParams();
  const { loadGrain } = useLoadStore();

  return (
    <div className="flex flex-col w-full mb-4 p-10">
      <GeneralGrainHeading status={status} load={loadGrain} />
      {id ? <GeneralGrainData load={loadGrain} /> : <GeneralGrainForm />}
    </div>
  );
};
